export default __webpack_public_path__ + "static/media/gallery_01.f7c21159.jpg";